"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _graphqlTag = _interopRequireDefault(require("graphql-tag"));
var _templateObject;
var applicationsEndpoint = function applicationsEndpoint(client) {
  return {
    get: function () {
      var _get = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var checkApplications;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              checkApplications = (0, _graphqlTag.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      mutation checkApplications {\n        checkApplications\n      }\n    "])));
              return _context.abrupt("return", client.graphqlClient.mutate({
                mutation: checkApplications
              }).then(function (_ref) {
                var data = _ref.data;
                var fetchedApplications = data.checkApplications.aplicacoes; // :facepalm:
                return fetchedApplications.filter(function (application) {
                  return application.nome.toLowerCase().trim() !== 'plurall';
                });
              }));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function get() {
        return _get.apply(this, arguments);
      }
      return get;
    }()
  };
};
var _default = applicationsEndpoint;
exports.default = _default;